"use client";

import { useState } from "react";
import { AxiosResponse } from "axios";

export const useApi = <T>(apiFunc: any, disableLoading?: boolean) => {
  const [data, setData] = useState<AxiosResponse | null>(null);
  const [error, setError] = useState<AxiosResponse | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);

  const request = async (data?: any) => {
    !disableLoading && setLoading(true);
    try {
      const result: AxiosResponse = await apiFunc({
        ...data,
      });

      setData(result);
      !disableLoading && setLoading(false);
      return result;
    } catch (err: any) {
      setError(err.response || "Error in request");
      !disableLoading && setLoading(false);
    }
  };

  return {
    data,
    error,
    loading,
    request,
  };
};

type ApiFunction<TInput, TOutput> = (params: TInput) => Promise<AxiosResponse<TOutput>>;

export function useApiRefactored<TInput = void, TOutput = any>(
  apiFunc: ApiFunction<TInput, TOutput>,
  disableLoading?: boolean
) {
  const [data, setData] = useState<TOutput | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);

  const request = async (params: TInput): Promise<TOutput> => {
    if (!disableLoading) setLoading(true);
    try {
      const response = await apiFunc(params);
      const result = response.data;
      setData(result);
      return result;
    } catch (err: any) {
      const extractedError = err?.response?.data ?? err?.message ?? "Unknown error";
      setError(extractedError);
      throw extractedError;
    } finally {
      if (!disableLoading) setLoading(false);
    }
  };

  return {
    data,
    error,
    loading,
    request,
  };
}
